import React, { useState, useEffect } from "react";
import { Box, Button, Snackbar, Typography, useTheme } from "@mui/material";
import Link from "next/link";
// store utils
import { useStore } from "outstated";
import { AppStore } from "pages/_app";
// mui
import { useRouter } from "next/router";
import sendSessionData from "components/global/ConsentBanner/utils/sendSessionData";

const ConsentBanner = () => {
  const router = useRouter();
  const theme = useTheme();

  const [open, setOpen] = useState(true);
  const [sessionData, setSessionData] = useState({
    Referrer: "",
    PathsData: [
      // { visitedOn: "", url: "", duration: 0, interactions: [] },
      // { visitedOn: "", url: "", duration: 0, interactions: [] },
      // { visitedOn: "", url: "", duration: 0, interactions: [] },
      // { visitedOn: "", url: "", duration: 0, interactions: [] },
      // { visitedOn: "", url: "exitted", duration: 0, interactions: [] },
    ],
    UID: "",
    TrackingConsent: "",
    DeviceType: "",
    Browser: "",
  });

  // Function to log interactions
  const logInteraction = (url, interaction) => {
    const uSessionData = Object.assign({}, sessionData);
    const currentPath = uSessionData.pathsData.find((path) => path.url === url);
    if (currentPath) {
      currentPath.interactions.push(interaction);
    }
    setSessionData(uSessionData);
  };

  const handleInteraction = (event) => {
    const interaction = {
      type: event.type,
      timestamp: new Date().toISOString(),
      details: event.target.outerHTML,
    };
    logInteraction(window.location.pathname, interaction);
  };

  const handleBeforeUnload = async (event) => {
    await sendSessionData(sessionData);
  };

  useEffect(() => {
    window.addEventListener("click", handleInteraction);
    window.addEventListener("scroll", handleInteraction);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("click", handleInteraction);
      window.removeEventListener("scroll", handleInteraction);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleAcceptAll = () => {
    console.log("All cookies accepted");
    setOpen(false);
  };

  const handleAcceptEssential = () => {
    console.log("Essential cookies accepted");
    setOpen(false);
  };

  const handleDenyAll = () => {
    console.log("All cookies denied");
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{
        "& .MuiSnackbarContent-root": {
          backgroundColor: theme.palette.common.white,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          padding: theme.spacing(2),
          maxWidth: "600px",
          width: "100%",
          boxShadow: theme.shadows[3],
        },
      }}
      message={
        <>
          <Typography
            variant="body2"
            sx={{
              flexGrow: 1,
              mb: { xs: 2, md: 0 },
              color: theme.palette.text.primary,
            }}
          >
            This website uses cookies to enhance your experience. By using our
            website, you consent to the use of cookies. You can read more in our{" "}
            <Link href="/privacy-policy" passHref>
              <a
                style={{
                  color: theme.palette.primary.main,
                  textDecoration: "underline",
                }}
              >
                privacy policy
              </a>
            </Link>
            .
          </Typography>
          <Button
            color="success"
            variant="outlined"
            onClick={handleAcceptAll}
            sx={{
              marginLeft: { md: 1 },
              marginBottom: { xs: 1, md: 0 },
              color: theme.palette.success.main,
              borderColor: theme.palette.success.main,
            }}
          >
            Accept
          </Button>
          <Button
            color="error"
            variant="outlined"
            onClick={handleDenyAll}
            sx={{
              marginLeft: { md: 1 },
              color: theme.palette.error.main,
              borderColor: theme.palette.error.main,
            }}
          >
            Deny
          </Button>
        </>
      }
    />
  );
};

export default ConsentBanner;
